/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BoundingBox
 */
export interface BoundingBox {
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    minLat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    maxLat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    minLon?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    maxLon?: number | null;
}

/**
 * Check if a given object implements the BoundingBox interface.
 */
export function instanceOfBoundingBox(value: object): value is BoundingBox {
    return true;
}

export function BoundingBoxFromJSON(json: any): BoundingBox {
    return BoundingBoxFromJSONTyped(json, false);
}

export function BoundingBoxFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoundingBox {
    if (json == null) {
        return json;
    }
    return {
        
        'minLat': json['minLat'] == null ? undefined : json['minLat'],
        'maxLat': json['maxLat'] == null ? undefined : json['maxLat'],
        'minLon': json['minLon'] == null ? undefined : json['minLon'],
        'maxLon': json['maxLon'] == null ? undefined : json['maxLon'],
    };
}

export function BoundingBoxToJSON(json: any): BoundingBox {
    return BoundingBoxToJSONTyped(json, false);
}

export function BoundingBoxToJSONTyped(value?: BoundingBox | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minLat': value['minLat'],
        'maxLat': value['maxLat'],
        'minLon': value['minLon'],
        'maxLon': value['maxLon'],
    };
}

